export const supportPhonesByCompanyGroupUuid: Record<
  string,
  {
    name: string;
    phone: string;
  }[]
> = {
  "c6d23e02-ceb8-43a2-a010-4606a3196847": [
    {
      name: "Agadir",
      phone: "+215 5 28 28 55 09",
    },
    {
      name: "Tanger",
      phone: "+215 5 39 32 18 12",
    },
  ],
};
